import CheckIcon from '@heroicons/react/24/outline/CheckIcon';

import { cn } from '@/services/utils';

interface DamPanelOptionProps {
    label: string;
    /** Shown in brackets after the label, e.g. the number of assets carrying a tag. */
    count?: number;
    isSelected: boolean;
    onToggle: () => void;
}

/**
 * Selectable row of the filter and tags panels (wireframe list item, e.g.
 * `I6392:31622;6476:92549;6244:5274;6476:737219`). A check mark marks the
 * selection; the check slot is reserved so labels do not shift.
 */
function DamPanelOption({ label, count, isSelected, onToggle }: DamPanelOptionProps) {
    return (
        <button
            type="button"
            aria-pressed={isSelected}
            onClick={onToggle}
            className={cn(
                'tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded tw-border-0 tw-bg-transparent tw-px-2 tw-py-2 tw-text-left lg:tw-py-1.5',
                'tw-text-t-sm tw-text-t-primary tw-transition-all tw-duration-100 tw-ease-in-out lg:tw-text-t-base',
                'hover:tw-bg-fill-primary-hover focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset focus-visible:tw-ring-ring',
            )}
        >
            <span className="tw-flex tw-h-4 tw-w-4 tw-shrink-0 lg:tw-h-5 lg:tw-w-5">
                {isSelected && <CheckIcon aria-hidden className="tw-h-4 tw-w-4 tw-icon-primary lg:tw-h-5 lg:tw-w-5" />}
            </span>
            <span className="tw-min-w-0 tw-flex-1 tw-break-words">
                {label}
                {count !== undefined && <span className="tw-text-t-secondary">{` (${count})`}</span>}
            </span>
        </button>
    );
}

export { DamPanelOption };
export type { DamPanelOptionProps };
